import React, { useState } from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import {
  Container,
  Button,
  Form
} from 'semantic-ui-react'

import {
  getValue
} from '_utils'

import MachineCountField from '_forms/machineCountField'
import SessionLengthField from '_forms/sessionLengthField'
import SessionRenewableField from '_forms/sessionRenewableField'
import IlokField from '_forms/ilokField'
import useCanAdminLicenses from '../../hooks/useCanAdminLicenses'

const sixMonthsInMinutes = 180 * 24 * 60

const getLicense = R.propOr({}, 'license')

const getIlokAccounts = R.compose(
  R.defaultTo([]),
  R.propOr([], 'ilok_accounts'),
  getLicense
)
const getSessionRenewable = R.compose(
  R.defaultTo(false),
  R.propOr(false, 'session_renewable'),
  getLicense
)
const getMachineCount = R.compose(
  R.defaultTo(4),
  R.tryCatch(parseInt, R.always(null)),
  R.propOr(4, 'machine_count'),
  getLicense
)
const getSessionLengthMinutes = R.compose(
  R.defaultTo(sixMonthsInMinutes),
  R.propOr(sixMonthsInMinutes, 'session_length_min'),
  getLicense
)

const Settings = (props) => {

  const canAdminLicense = useCanAdminLicenses();
  const [values, setValues] = useState({
    lengthInMinutes: getSessionLengthMinutes(props),
    machineCount: getMachineCount(props),
    renewable: getSessionRenewable(props),
    ilokAccounts: getIlokAccounts(props),
    dirty: false
  });

  const onValueChange = (e, { name, type, value, checked }) => {
    // console.log('value', value, R.type(value), 'type', type)
    setValues(Object.assign(
      {},
      values,
      {
        [name]: getValue({name, type, value, checked}),
        dirty: true
      })
    );
  }

  const onCancel = () => {
    setValues({
      lengthInMinutes: getSessionLengthMinutes(props),
      machineCount: getMachineCount(props),
      renewable: getSessionRenewable(props),
      ilokAccounts: getIlokAccounts(props),
      dirty: false
    });
  };

  const onSave = () => {
    if (props.onModifyLicense) {
      props.onModifyLicense({
        licenseId: R.path(['license', '_id'], props),
        payload: {
          machine_count: values.machineCount,
          session_length_min: values.lengthInMinutes,
          session_renewable: values.renewable,
          ilok_accounts: values.ilokAccounts
        }
      })
      setValues(Object.assign(values, { dirty: false }));
    }
  }

  return (
    <Form as={Container}>
      <Form.Group >
        <SessionLengthField readOnly={ !canAdminLicense } width={7} name='lengthInMinutes' lengthInMinutes={values.lengthInMinutes} onChange={onValueChange} />
        <MachineCountField readOnly={ !canAdminLicense } width={6} name='machineCount' machineCount={values.machineCount} onChange={onValueChange} />
        <SessionRenewableField readOnly={ !canAdminLicense } width={3} name='renewable' renewable={values.renewable || false} onChange={onValueChange} />
      </Form.Group >
      <Form.Group >
        <IlokField readOnly={ !canAdminLicense } width={16} name='ilokAccounts' ilokAccounts={values.ilokAccounts || []} onChange={onValueChange} />
      </Form.Group>
      {
        !canAdminLicense ? null : (
          <Button.Group>
            <Button disabled={!values.dirty} onClick={onCancel}>Cancel</Button>
            <Button.Or />
            <Button positive={values.dirty} disabled={!values.dirty} onClick={onSave}>Save</Button>
          </Button.Group>
        )
      }
    </Form>
  )
}

Settings.propTypes = {
  license: PropTypes.object.isRequired,
  onModifyLicense: PropTypes.func.isRequired
}

export default Settings



// WEBPACK FOOTER //
// ./webAdmin/views/license/settings.js